<template>
    <section id="testimonials" class="banner half hide-indicators" :style="{ backgroundImage: 'url(' + this.quoteData.backgroundImg + ')' }">
        <article v-for="(testimony, index) in quoteData.quotes" :key="index">
            <div class="inner">
                <header>
                    <h3 v-html="testimony.quote"></h3>
                    <span>~ {{testimony.author}}</span>
                </header>
            </div>
        </article>
    </section>
</template>

<script>
export default {
    props : {
        quoteData : Object
    },
    data() {
        return {
            timer: null,
            currentIndex: 0
        }
    },
    mounted: function() {
        this.startSlide();
    },
    methods: {
        startSlide: function() {
            this.toggleActiveClass(true);
            this.timer = setInterval(this.next, 5000);
        },
        next: function() {
            this.toggleSlide(this.currentIndex + 1)
        },
        toggleSlide: function(index){
            this.toggleActiveClass(false);
            this.currentIndex = index;
            this.toggleActiveClass(true);
        },
        toggleActiveClass(isAddClass) {
            var article = this.$el.querySelectorAll("#testimonials article")[this.currentIndexAbsolute];

            if (isAddClass === true) {
                article.classList.add("active");
            } else {
                article.classList.remove("active");
            }
        },
    },
    computed: {
        currentIndexAbsolute: function() {
            return Math.abs(this.currentIndex) % this.quoteData.quotes.length;
        }
    }
}
</script>

<style scoped>
#testimonials {
	background-position: center center;
	background-size: cover;
}
</style>